
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

export default function CTA() {
  const { t } = useTranslation('home');

  return (
    <section className="py-20 bg-[#F5F7FA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="bg-[#0D1B2A] rounded-3xl p-12 lg:p-16 text-center relative overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-5">
            <div className="w-full h-full" style={{
              backgroundImage: `
                linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
                linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)
              `,
              backgroundSize: '40px 40px'
            }}></div>
          </div>

          <div className="relative z-10 max-w-4xl mx-auto">
            <h2 className="text-3xl lg:text-5xl font-bold text-white mb-6 tracking-tight">
              {t('cta.title')}
            </h2>
            
            <p className="text-xl text-[#C0C0C0] mb-8 leading-relaxed max-w-2xl mx-auto">
              {t('cta.subtitle')}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button variant="primary" className="text-lg px-8 py-4 bg-[#2E8BC0] hover:bg-white hover:text-[#0D1B2A]">
                {t('cta.consultation')}
              </Button>
              <Button variant="secondary" className="text-lg px-8 py-4 border-white text-white hover:bg-white hover:text-[#0D1B2A]">
                {t('cta.brochure')}
              </Button>
            </div>

            {/* Contact Options */}
            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex items-center justify-center space-x-3 text-[#C0C0C0]">
                <i className="ri-phone-line text-[#2E8BC0] text-xl"></i>
                <div>
                  <div className="text-sm text-[#C0C0C0]/80">{t('cta.callSales')}</div>
                  <div className="font-mono text-sm">+421 (903) 850-153</div>
                </div>
              </div>
              
              <div className="flex items-center justify-center space-x-3 text-[#C0C0C0]">
                <i className="ri-mail-line text-[#2E8BC0] text-xl"></i>
                <div>
                  <div className="text-sm text-[#C0C0C0]/80">{t('cta.emailUs')}</div>
                  <div className="font-mono text-sm">office@bulkcomsro.com</div>
                </div>
              </div>
              
              <div className="flex items-center justify-center space-x-3 text-[#C0C0C0]">
                <i className="ri-map-pin-line text-[#2E8BC0] text-xl"></i>
                <div>
                  <div className="text-sm text-[#C0C0C0]/80">{t('cta.address')}</div>
                  <div className="font-mono text-sm">Gorkého 129/10, Bratislava</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
